function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { getCartLocalStorage, countProductLocalStorage, translate } from '../utils/helpers';

var CartHeader = /*#__PURE__*/function (_Component) {
  _inherits(CartHeader, _Component);

  var _super = _createSuper(CartHeader);

  function CartHeader(props) {
    var _this;

    _classCallCheck(this, CartHeader);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getProductsCount", function () {
      var productsCount = countProductLocalStorage(getCartLocalStorage());
      return productsCount > 99 ? 99 : productsCount;
    });

    _this.state = {
      productsCount: _this.getProductsCount()
    };
    return _this;
  }

  _createClass(CartHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      $('#cart-counter').on('change', function () {
        setTimeout(function () {
          _this2.setState({
            productsCount: _this2.getProductsCount()
          });
        }, 300);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "cart"
      }, /*#__PURE__*/React.createElement("div", {
        className: "up-line"
      }, /*#__PURE__*/React.createElement("svg", {
        className: "svg-color",
        width: "20px",
        height: "19px",
        viewBox: "0 0 20 19",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("g", {
        id: "Menu-Header",
        transform: "translate(-1088.000000, -29.000000)",
        stroke: "#181818"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(1050.000000, 20.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(38.000000, 10.000000)"
      }, /*#__PURE__*/React.createElement("polyline", {
        stroke: "#27929a",
        points: "0 0 2.5824969 1.16114626 3.03879553 3.29765538 5.07200857 13 17 13"
      }), /*#__PURE__*/React.createElement("polyline", {
        stroke: "#27929a",
        points: "4.55945232 11 17.3089118 11 19 4 3 4"
      }), /*#__PURE__*/React.createElement("path", {
        stroke: "#27929a",
        d: "M9,16 C9,15.4475743 8.55225049,15 8.00039139,15 C7.44774951,15 7,15.4475743 7,16 C7,16.5524257 7.44774951,17 8.00039139,17 C8.55225049,17 9,16.5524257 9,16 Z"
      }), /*#__PURE__*/React.createElement("path", {
        stroke: "#27929a",
        d: "M15,16 C15,15.4475743 14.5522505,15 13.9996086,15 C13.4477495,15 13,15.4475743 13,16 C13,16.5524257 13.4477495,17 13.9996086,17 C14.5522505,17 15,16.5524257 15,16 Z"
      })))))), /*#__PURE__*/React.createElement("span", {
        className: "main-txt"
      }, this.state.productsCount)), /*#__PURE__*/React.createElement("span", {
        className: "d-none d-lg-flex"
      }, translate('CART', 'PANIER')));
    }
  }]);

  return CartHeader;
}(Component);

export default CartHeader;